var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline green",on:{"click":function($event){return _vm.nextPage()}}},[_vm._v("\n    View more\n")])}
var staticRenderFns = []
export { render, staticRenderFns }